import { logContact } from '../services/communicationLog';
import CallTalkingPoints from './CallTalkingPoints';
import React, { useState } from 'react';

// Shows on the home sale contingency task. Pick the listing agent (other home) or the client,
// then call, text, or email. Text and Email open an editable default message with a Send button.
const textFor = (who, first) => {
  const hi = `Hi ${first || 'there'}, this is Kelly Olin with RESIDENCE | eXp Realty.`;
  if (who === 'agent') {
    return `${hi} I'm working with my buyer on the home-to-sell contingency for their home and would love to check in on where things stand. Call or text me at 239-488-5900.`;
  }
  return `${hi} I'm checking in on your home sale and the next steps for your move. Call or text me at 239-488-5900.`;
};

const subjectFor = (who) => (who === 'agent' ? 'Home sale status for my buyer' : 'Checking in on your home sale');

const emailFor = (who, first) => `${textFor(who, first)}\n\nKelly Olin\nCo-Founder & Team Leader | RESIDENCE | eXp Realty\nCall or text: 239-488-5900\nKelly.Olin@eXpRealty.com`;

export default function HomeSaleContactQuickContact({ task, listingAgent, client, onSent }) {
  const taskName = task.name || task.title || '';
  const [who, setWho] = useState('');
  const [open, setOpen] = useState(null); // null | 'text' | 'email'
  const [text, setText] = useState('');
  const [subject, setSubject] = useState('');
  const [body, setBody] = useState('');

  if (!/home sale contingency/i.test(taskName)) return null;

  const people = { agent: listingAgent || {}, client: client || {} };
  const p = who ? people[who] : null;
  const first = p?.firstName || '';
  const name = p ? `${p.firstName || ''} ${p.lastName || ''}`.trim() : '';
  const digits = (p?.phone || '').replace(/[^0-9+]/g, '');
  const email = p?.email || '';

  const btn = { display: 'inline-block', padding: '8px 14px', borderRadius: 6, fontWeight: 700, fontSize: 13, textDecoration: 'none', border: '1px solid #B8962E', background: '#B8962E', color: '#FFFFFF', cursor: 'pointer' };
  const btnOff = { ...btn, background: '#FFFFFF', color: '#B8962E', borderColor: '#D5D9E0', pointerEvents: 'none', opacity: 0.5 };
  const btnCancel = { ...btn, background: '#FFFFFF', color: '#5B6270', borderColor: '#D5D9E0' };

  const pick = (key) => {
    setWho(key);
    setOpen(null);
  };

  const toggle = (mode) => {
    if (open === mode) { setOpen(null); return; }
    if (mode === 'text') setText(textFor(who, first));
    if (mode === 'email') { setSubject(subjectFor(who)); setBody(emailFor(who, first)); }
    setOpen(mode);
  };

  return (
    <div style={{ margin: '6px 0' }}>
      <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 8 }}>
        <select value={who} onChange={(e) => pick(e.target.value)} style={{ padding: '8px 10px', borderRadius: 6, border: '1px solid #D5D9E0', fontSize: 13, minWidth: 200 }}>
          <option value="">Contact who?</option>
          <option value="agent">Listing agent (other home)</option>
          <option value="client">Client</option>
        </select>
        {who && (
          <>
            <span style={{ fontSize: 13, color: '#1A1A1A', fontWeight: 600 }}>{name || 'No name saved'}</span>
            <a href={digits ? `tel:${digits}` : undefined} style={digits ? btn : btnOff} onClick={() => logContact(task.transactionId, { kind: 'call', toPhone: digits, role: 'Listing Agent', taskName: task.name || task.title || '' })}>Call</a>
        <CallTalkingPoints task={task} />
            <button type="button" onClick={() => toggle('text')} disabled={!digits} style={digits ? btn : btnOff}>Text</button>
            <button type="button" onClick={() => toggle('email')} disabled={!email} style={email ? btn : btnOff}>Email</button>
            {digits && <span style={{ fontSize: 13, color: '#5B6270' }}>{p.phone}</span>}
            {email && <span style={{ fontSize: 13, color: '#5B6270' }}>{email}</span>}
          </>
        )}
      </div>
      {who && !digits && !email && (
        <p style={{ fontSize: 12, color: '#5B6270', margin: '6px 0 0' }}>No phone or email saved for this contact yet.</p>
      )}
      {open === 'text' && digits && (
        <div style={{ marginTop: 8, padding: 10, border: '1px solid #D5D9E0', borderRadius: 8, background: '#FFFFFF' }}>
          <textarea value={text} onChange={(e) => setText(e.target.value)} rows={4} style={{ width: '100%', boxSizing: 'border-box', padding: 8, borderRadius: 6, border: '1px solid #D5D9E0', fontSize: 14, fontFamily: 'inherit', color: '#1A1A1A' }} />
          <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
            <a href={`sms:${digits}?body=${encodeURIComponent(text)}`} style={btn} onClick={() => onSent && onSent()}>Send</a>
            <button type="button" onClick={() => setOpen(null)} style={btnCancel}>Cancel</button>
          </div>
        </div>
      )}
      {open === 'email' && email && (
        <div style={{ marginTop: 8, padding: 10, border: '1px solid #D5D9E0', borderRadius: 8, background: '#FFFFFF' }}>
          <input value={subject} onChange={(e) => setSubject(e.target.value)} style={{ width: '100%', boxSizing: 'border-box', padding: 8, borderRadius: 6, border: '1px solid #D5D9E0', fontSize: 14, marginBottom: 8 }} />
          <textarea value={body} onChange={(e) => setBody(e.target.value)} rows={9} style={{ width: '100%', boxSizing: 'border-box', padding: 8, borderRadius: 6, border: '1px solid #D5D9E0', fontSize: 14, fontFamily: 'inherit', color: '#1A1A1A' }} />
          <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
            <a href={`mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`} style={btn} onClick={() => onSent && onSent()}>Send</a>
            <button type="button" onClick={() => setOpen(null)} style={btnCancel}>Cancel</button>
          </div>
        </div>
      )}
    </div>
  );
}
